import { iActionClear } from '~/domain/interfaces/redux/Consultant/clear';
import { ConsultantTypes } from '~/domain/interfaces/redux/Consultant/create';

export const clearRequest = (): iActionClear => ({
  type: ConsultantTypes.CLEAR,
});
